<template>
  <div class="AboutActivityDetails clearfix">
    <h2>{{ActivityTable.title}}</h2>
    <em>{{ ActivityTable.createTime }}</em>
    <div class="text">
      <div v-html="ActivityTable.content">{{ActivityTable.content}}</div>
    </div>
  </div>
</template>

<script>
import { reqGetActivityDetail } from '../../../api/'
import PubSub from 'pubsub-js'
import MapLoader from '../../../js/AMap.js'
import AMapUI from 'AMapUI'

export default {
  name: 'AboutActivityDetails',
  data () {
    return {
      ActivityTable: []
    }
  },
  created () {
    console.log('this.$route.params.ActivityId', this.$route.params.ActivityId)
    reqGetActivityDetail(this.$route.params.ActivityId).then(res=> {
      PubSub.publish('activityTypeId', res.data.activityType)
      this.ActivityTable = res.data
    })
  },
  methods: {
  },
  mounted () {   
    let that = this
  },
  components: {
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../../css-styl/mixins.styl'

  .AboutActivityDetails
    h2
      font-size 24px
      font-weight 600
      padding 20px 14px 14px
      border-bottom 1px solid #e4e4e4
    em
      font-size 14px
      font-style normal
      color #666
      margin-left 14px
      margin-top 14px
      display inline-block 
    .text
      font-size 16px
      line-height 30px 2
      padding 30px 20px 20px 20px
</style>



// WEBPACK FOOTER //
// src/pages/aboutpages/details/AboutActivityDetails.vue